import { createAnalyticsUrl, restGet } from '~/src/dash/api/rest';

export interface IEndpointShieldHistoryItem {
  id: number;
  hash: string;
  ts_date: string;
  site_id: number;
  app_bundle: string;
  country: string;
  endpoint_requests: number;
  impressions: number;
  throttle_percentage: number;
  triggered: boolean;
}

export interface IEndpointBlockedRow {
  day: string;
  event_endpoint_blocked_code: number;
  total_blocked: number | null;
  endpoint_requests: number | null;
  impressions: number | null;
  app_bundle: string | null;
  country: string | null;
  hash: string;
}

export interface IEndpointShieldHistoryResponse {
  success: boolean;
  site_id: number;
  start_date: string;
  end_date: string;
  count: number;
  data: IEndpointShieldHistoryItem[];
  blocked_count: number;
  blocked_data: IEndpointBlockedRow[];
}

export async function getEndpointShieldHistory(
  siteId: string,
  publisherId: string,
): Promise<[IEndpointShieldHistoryResponse | undefined, Error | undefined]> {
  const reqUrl = `${createAnalyticsUrl('endpoint_shield_history', publisherId)}&site_id=${siteId}`;
  try {
    const response = await restGet<IEndpointShieldHistoryResponse>(reqUrl, {});
    return [response.parsedBody, undefined];
  } catch (e) {
    return [undefined, e as Error];
  }
}
